
import { image } from '@/helpers/assets'

export const layers = [
  /**
   * The results layer
   */  
  {
    id: 'hexagons',
    label: 'De prognose resultaten',
    ignore: true,
    required: true,
    status: 'primary',
    type: 'results',
    sourceNameHint: 'resultaat_per_hexagon',
    tooltip: 'De resultaten van de prognose analyse, weergegeven in hexagonen'
  },
  /**
   * Data Layers
   */
  {
    id: 'fuelstations',
    label: 'Pompstation',
    icon: {
      slug: image({ name: 'legend/fuelpump.svg' }),
      width: 20
    },
    visible: true,
    status: 'secondary',
    type: 'context',
    sourceNameHint: 'tankstations',
    tooltip: 'De huidige benzine stations'
  },
  {
    id: 'lngcng',
    label: 'LNG / CNG',
    icon: {
      slug: image({ name: 'legend/fuelpump.svg' }),
      width: 20
    },
    visible: true,
    status: 'secondary',
    type: 'context',
    sourceNameHint: 'lngcng',
    tooltip: 'De huidige LNG / CNG pompstations'
  },
  {
    id: 'pplusr',
    label: 'Park + Ride',
    icon: {
      svg: false,
      slug: image({ name: 'legend/Parkandride-icon.svg' }),
      width: 20
    },
    visible: true,
    status: 'secondary',
    type: 'context',
    sourceNameHint: 'penr',
    tooltip: 'P & R - Let op: deze informatie is niet altijd compleet'
  },
  {
    id: 'ls',
    label: 'Laagspanning',
    icon: {
      slug: image({ name: 'legend/ls.png' }),
      width: 15
    },
    visible: true,
    layers: ['ls', 'ovkasten', 'ovkasten-labels'],
    status: 'primary',
    type: 'context',
    sourceNameHint: 'laagspanning',
    tooltip: 'Het laagspanningsnet. Data van de netbeheerder'
  },
  {
    id: 'evmaps_nl_ms_kabels',
    label: 'Middenspanning',
    icon: {
      slug: image({ name: 'legend/middenspanning.png' }),
      width: 15
    },
    visible: true,
    status: 'secondary',
    type: 'national',
    // sourceNameHint: 'middenspanning',
    tooltip: 'Het Middenspanningsnet. Data van de netbeheerder'
  },
  {
    id: 'evmaps_nl_ls_stations',
    label: 'Laagspanningskasten',
    icon: {
      slug: image({ name: 'legend/middenspanning.png' }),
      width: 15
    },
    visible: true,
    status: 'secondary',
    type: 'national',
    // sourceNameHint: 'middenspanning',
    tooltip: 'De laagspanningskasten. Data van de netbeheerder'
  },
  {
    id: 'evmaps_nl_ms_stations',
    label: 'Middenspanningskasten',
    icon: {
      slug: image({ name: 'legend/middenspanning.png' }),
      width: 15
    },
    visible: true,
    status: 'secondary',
    type: 'national',
    // sourceNameHint: 'middenspanning',
    tooltip: 'De Middenspanningskasten. Data van de netbeheerder'
  },
  {
    id: 'evmaps_nl_ms_ls_stations',
    label: 'Laag-/Middenspanningskasten',
    icon: {
      slug: image({ name: 'legend/middenspanning.png' }),
      width: 15
    },
    visible: true,
    status: 'secondary',
    type: 'national',
    // sourceNameHint: 'middenspanning',
    tooltip: 'De Laag-/Middenspanningskasten. Data van de netbeheerder'
  },
  {
    id: 'nwegen',
    label: 'N Wegen',
    icon: {
      slug: image({ name: 'legend/ls.png' }),
      width: 15
    },
    visible: true,
    status: 'primary',
    type: 'context',
    sourceNameHint: 'nwegen',
    tooltip: 'De N Wegen'
  },
  {
    id: 'evmaps_nl_verkeersstromen',
    label: 'Verkeersstromen',
    icon: {
      slug: image({ name: 'legend/trafficflow.png' }),
      width: 15
    },
    visible: true,
    status: 'secondary',
    type: 'national',
    // sourceNameHint: 'gemeentelijke_eigendom',
    tooltip: 'De verkeersintensiteit in rood tinten.'
  },
  {
    id: 'parking',
    label: 'Parkeervlak',
    icon: {
      slug: image({ name: 'legend/parkeren.png' }),
      width: 15
    },
    visible: true,
    status: 'primary',
    type: 'context',
    sourceNameHint: 'parkeervlakken',
    tooltip: 'Parkeervlakken vanuit de GIS analyse. Geen exacte data.'
  },

  {
    id: 'parkeerdruk',
    label: 'Parkeerdruk',
    icon: {
      slug: image({ name: 'legend/parkeerdruk.png' }),
      width: 15
    },
    visible: true,
    status: 'primary',
    type: 'context',
    sourceNameHint: 'parkeerdruk',
    tooltip: 'Parkeerdruk.'
  },
  {
    id: 'trees',
    label: 'Boom',
    icon: {
      slug: image({ name: 'legend/boom.png' }),
      width: 15
    },
    visible: true,
    status: 'secondary',
    type: 'context',
    sourceNameHint: 'bomenregister',
    tooltip: 'De bomen binnen de gemeente, veelal aangeleverd door de gemeente'
  },
  {
    id: 'trees_zone',
    label: 'Boom (met zone)',
    icon: {
      slug: image({ name: 'legend/boom.png' }),
      width: 15
    },
    visible: true,
    status: 'secondary',
    type: 'context',
    layers: ['trees_p', 'trees_z'],
    sourceNameHint: 'boombeschermzone_p',
    tooltip: 'De bomen binnen de gemeente, inclusief beschermzone'
  },
  {
    id: 'evmaps_nl_zh_nieuwbouwlocaties',
    label: 'Bouwlocaties',
    icon: {
      slug: image({ name: 'legend/construction-regular.png' }),
      width: 15
    },
    visible: true,
    status: 'primary',
    type: 'national',
    tooltip: 'Klik op de locatie voor details'
  },
  {
    id: 'evmaps_nl_zh_toplocaties',
    label: 'Top Locaties',
    icon: {
      slug: image({ name: 'legend/top-location.png' }),
      width: 15
    },
    visible: true,
    status: 'primary',
    type: 'national',
    tooltip: 'Winkelcentra, zembaden, religieuze gebouwen, etc. Klik op de locatie voor details.'
  },
  {
    id: 'visitorlocations',
    label: 'Bezoekerslocatie',
    icon: {
      svg: false,
      slug: image({ name: 'legend/locaties.png' }),
      width: 15
    },
    visible: true,
    status: 'secondary',
    type: 'context', 
    sourceNameHint: 'bezoekers_hexid',
    tooltip: 'Locaties waar vermoedelijk verkeer op af komt'
  },
  {
    id: 'worklocations',
    label: 'Werklocaties',
    icon: {
      svg: false,
      slug: image({ name: 'legend/locaties.png' }),
      width: 15
    },
    visible: true,
    status: 'secondary',
    type: 'context',
    sourceNameHint: 'forenzen',
    tooltip: 'Locaties waar vermoedelijk forenzen verkeer op af komt'
  },
  {
    id: 'lichtmasten',
    label: 'Lichtmasten',
    icon: {
      svg: false,
      slug: image({ name: 'legend/locaties.png' }),
      width: 15
    },
    visible: true,
    status: 'secondary',
    type: 'context', 
    sourceNameHint: 'lichtmasten',
    tooltip: 'Lichtmasten'
  },
  {
    id: 'straatmeubilair',
    label: 'Straat meubilair',
    icon: {
      svg: false,
      slug: image({ name: 'legend/locaties.png' }),
      width: 15
    },
    visible: true,
    status: 'secondary',
    type: 'context', 
    sourceNameHint: 'straatmeubilair',
    tooltip: 'Straat meubilair'
  },
  
  // {
  //   id: 'border',
  //   label: 'Gebiedsgrens',
  //   icon: {
  //     slug: image({ name: 'legend/border.png' }),
  //     width: 15
  //   },
  //   visible: true,
  //   status: 'secondary',
  //   type: 'context',
  //   sourceNameHint: 'gemeentegrens',
  //   tooltip: 'De grens van het prognose gebied. Op uitzonderingen na is dit de gemeentegrens.'
  // },

  {
    id: 'nieuwbouw',
    label: 'Gebiedsontwikkeling',
    icon: {
      slug: image({ name: 'legend/nieuwbouw.png' }),
      width: 15
    },
    visible: true,
    status: 'secondary',
    type: 'context',
    sourceNameHint: 'nieuwbouw_locaties',
    tooltip: 'Gebiedsontwikkeling locaties in de gemeente.'
  },

  {
    id: 'monuments',
    label: 'Gemeentelijke monumenten',
    icon: {
      slug: image({ name: 'legend/monuments.png' }),
      width: 15
    },
    visible: true,
    status: 'secondary',
    type: 'context',
    sourceNameHint: 'gemeente_monument',
    tooltip: 'Gemeentelijke monumenten.'
  },

  {
    id: 'deelgebied_vlak',
    label: 'Deelgebieden',
    icon: {
      slug: image({ name: 'legend/parkeren.png' }),
      width: 15
    },
    layers: ['deelgebied_vlak', 'deelgebied_vlak_text', 'deelgebied_lijn'],
    visible: true,
    status: 'primary',
    type: 'context',
    sourceNameHint: 'deelgebied_vlak',
    tooltip: 'De gemeente opgesplitst in 4 types buurten.'
  },

  {
    id: 'grondeigendom',
    label: 'Grondeigendom',
    icon: {
      slug: image({ name: 'legend/grondeigendom.png' }),
      width: 15
    },
    visible: true,
    status: 'secondary',
    type: 'context',
    sourceNameHint: 'gemeentelijke_eigendom',
    tooltip: 'De grond welke in eigendom is van de gemeente / overheid.'
  },
  
  {
    id: 'evmaps_nl_rws_beheergebied',
    label: 'Rijkswaterstaat',
    icon: {
      slug: image({ name: 'legend/grondeigendom.png' }),
      width: 15
    },
    visible: true,
    status: 'secondary',
    type: 'national',
    // sourceNameHint: 'gemeentelijke_eigendom',
    tooltip: 'De grond welke in eigendom is van Rijkswaterstaat.'
  },

  /**
   * Planmode
   */
  {
    id: 'chargingpoints-realized',
    label: 'Gerealiseerde laadpaal',
    icon: {
      slug: image({ name: 'legend/chargingpoint-realized.png' }),
      width: 20
    },
    visible: true,
    status: 'primary',
    ignore: true,
    type: 'planmode', 
    tooltip: 'De reeds gerealiseerde laadpaal locaties'
  },
  {
    id: 'chargingpoints-in-progress',
    label: 'In voorbereiding',
    icon: {
      slug: image({ name: 'legend/chargingpoint-in-progress.png' }),
      width: 20
    },
    visible: true,
    status: 'primary',
    ignore: true,
    type: 'planmode', 
    tooltip: 'Deze laadpaal wordt binnenkort gerealiseerd'
  },
  {
    id: 'chargingpoints-definitive',
    label: 'Gevalideerde laadpaal',
    icon: {
      slug: image({ name: 'legend/chargingpoint-definitive.png' }),
      width: 20
    },
    visible: true,
    status: 'primary',
    ignore: true,
    type: 'planmode', 
    tooltip: 'Deze laadpaal is definitief gepland'
  },
  {
    id: 'chargingpoints-suggestion',
    label: 'Voorgestelde laadpaal',
    icon: {
      slug: image({ name: 'legend/chargingpoint-suggestion.png' }),
      width: 20
    },
    visible: true,
    status: 'primary',
    ignore: true,
    type: 'planmode', 
    tooltip: 'Een voorstel om deze locatie in te plannen'
  },
  {
    id: 'chargingpoints-rejected',
    label: 'Afgekeurde laadpaal',
    icon: {
      slug: image({ name: 'legend/chargingpoint-rejected.png' }),
      width: 20
    },
    visible: true,
    status: 'primary',
    ignore: true,
    type: 'planmode',
    tooltip: 'Een afgekeurde laadpaal'
  },
  {
    id: 'chargingpoints-alert',
    label: 'Aandachtspunt',
    icon: {
      slug: image({ name: 'legend/chargingpoint-alert.png' }),
      width: 20
    },
    visible: true,
    status: 'primary',
    ignore: true,
    type: 'planmode', 
    tooltip: 'Dit punt markeert een aandachtspunt'
  },
  {
    id: 'chargingpoints-realized-private',
    label: 'Gerealiseerd semi-publiek',
    icon: {
      slug: image({ name: 'legend/chargingpoint-realized-private.png' }),
      width: 20
    },
    visible: false,
    status: 'primary',
    ignore: true,
    type: 'planmode', 
    tooltip: 'De reeds gerealiseerde laadpaal locaties (semi-publiek)'
  },
  {
    id: 'chargingpoints-fastcharger-realized',
    label: 'Gerealiseerde snellader',
    icon: {
      slug: image({ name: 'legend/chargingpoint-fastcharger-realized.png' }),
      width: 20
    },
    visible: true,
    status: 'primary',
    ignore: true,
    type: 'planmode', 
    tooltip: ''
  },
  {
    id: 'chargingpoints-fastcharger-planned',
    label: 'Geplande snellader',
    icon: {
      slug: image({ name: 'legend/chargingpoint-fastcharger-planned.png' }),
      width: 20
    },
    visible: true,
    status: 'primary',
    ignore: true,
    type: 'planmode', 
    tooltip: ''
  },
  {
    id: 'chargingpoints-fastcharger-rejected',
    label: 'Afgekeurde snellader laadpaal',
    icon: {
      slug: image({ name: 'legend/chargingpoint-fastcharger-rejected.png' }),
      width: 20
    },
    visible: true,
    status: 'primary',
    ignore: true,
    type: 'planmode',
    tooltip: 'Een afgekeurde snellader laadpaal'
  },

  /**
   * Ignore - added for Admin panel
   */
  {
    id: 'ovkasten',
    label: 'Laagspanning - OV Kasten',
    ignore: true,
    status: 'secondary',
    type: 'context',
    sourceNameHint: 'ov_kasten',
    tooltip: 'De locatie van OV kasten is optionele data in de laagspannings kaart laag.'
  },
  {
    id: 'trees_zone_z',
    label: 'Bomen - beschermzone',
    ignore: true,
    type: 'context',
    status: 'secondary',
    sourceNameHint: 'boombeschermzone',
    tooltip: 'De beschermzone om bomen.'
  },

  {
    id: 'deelgebied_lijn',
    label: 'Deelgebiedgrensen',
    ignore: true,
    status: 'secondary',
    type: 'context',
    sourceNameHint: 'deelgebied_lijn',
    tooltip: 'Gestippelde lijn die de grensen van de deelgebieden markeren'
  },

]

export const dataLayers = layers.filter(layer => layer.type !== 'planmode' && !layer.ignore)

export const planmodeLayers = layers.filter(layer => layer.type === 'planmode')
